import { environment } from 'src/environments/environment';
import { AFUser } from './../models/authentication.model';

/**
 * Converte a retrieved firebase user into the afUser interface
 * @param user Firebase User
 */
export function convertAfUser(user: firebase.default.User): AFUser {

  const afUser: Partial<AFUser> = {
    emailVerified: user.emailVerified,
    uid: user.uid
  };


  if (environment.environment == 'development') {
    afUser.emailVerified = true;
    afUser.uid = '';
    afUser.displayName = 'usuario local';
    afUser.email = (user as any).user ? (user as any).user.email : user.email;
    afUser.photoURL = '';
    afUser.provider = 'password';
  } else {
    if (user.providerData && user.providerData.length > 0) {
      const pd = user.providerData[0];
      const pl = user;
      afUser.displayName = pd.displayName || pl.displayName;
      afUser.email = pd.email || pl.email;
      afUser.photoURL = pd.photoURL || pl.photoURL;
      afUser.provider = pd.providerId;
    } else {
      const pl = user;
      afUser.displayName = pl.displayName;
      afUser.email = pl.email;
      afUser.photoURL = pl.photoURL;
      afUser.provider = pl.providerId;
    }
  }

  return afUser as AFUser;
}

/**
 * Verify if the user has and verified e-mail or logged with other providers
 */
export function isEmailVerifiedOrProvider(user: AFUser) {
  if (user.provider == 'password') {
    return user.emailVerified;
  }
  return true;
}
